import { render, staticRenderFns } from "./InfoPublic.vue?vue&type=template&id=5c33b4cc&scoped=true"
import script from "./InfoPublic.vue?vue&type=script&lang=js"
export * from "./InfoPublic.vue?vue&type=script&lang=js"
import style0 from "./InfoPublic.vue?vue&type=style&index=0&id=5c33b4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c33b4cc",
  null
  
)

export default component.exports